import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { ChangeFullnameFormProps } from './types';
import { useDisclosure } from '@src/core/hooks';
import { useUpdateProfileMutation } from '@src/features/profile/redux';
import { IUserChangeFullnameForm } from '@src/features/profile/entites';
import { Controller, useForm } from 'react-hook-form';
import { EMPTY_STRING, EMPTY_VALUE, REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ArcButton, ArcDialog, ArcIconButton, ArcOutlinedInput, ArcStack, ArcText } from '@src/core/ui';
import { toast } from 'react-toastify';

const ChangeFullnameForm: React.FC<ChangeFullnameFormProps> = (props) => {
  const { profile } = props;
  const { open, show, hide } = useDisclosure();
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();

  const { control, formState: { errors }, handleSubmit } = useForm<IUserChangeFullnameForm>({
    defaultValues: {
      lastname: profile?.lastname ?? EMPTY_VALUE,
      firstname: profile?.firstname ?? EMPTY_VALUE,
    }
  });

  const onUpdateProfile = (form: IUserChangeFullnameForm) => {
    updateProfile({ 
      phone: profile?.phone ?? EMPTY_VALUE, 
      lastname: form.lastname, 
      firstname: form.firstname, 
    }).unwrap().then(() => {
      toast.success('UPDATE PROFILE SUCCESS TEXT');
      hide();
    }).catch(() => {});
  };


  return (
    <React.Fragment>
      <ArcStack 
        spacing={1}
        direction='row' 
        alignItems='center'>
        <ArcText.h2> 
          {profile?.firstname || EMPTY_STRING} {profile?.lastname || EMPTY_STRING} 
        </ArcText.h2>
        <ArcIconButton size='small' onClick={show}>
          <EditIcon sx={{ fontSize: 16 }} />
        </ArcIconButton>
      </ArcStack>
      <ArcDialog open={open} onClose={hide} title='Change Name'>
        <ArcStack 
          p={2} 
          spacing={2} 
          component='form' 
          onSubmit={handleSubmit(onUpdateProfile)}>

          <Controller 
            name='firstname' 
            control={control} 
            rules={{ required: REQUIRED_VALIDATION_TEXT }}
            render={({ field }) => (
              <ArcOutlinedInput 
                {...field} 
                label='First Name'
                autoComplete='off'
                error={Boolean(errors.firstname)} 
                helperText={errors.firstname?.message} />
            )} />
            
          <Controller 
            name='lastname' 
            control={control} 
            rules={{ required: REQUIRED_VALIDATION_TEXT }}
            render={({ field }) => (
              <ArcOutlinedInput 
                {...field} 
                label='Last Name'
                autoComplete='off'
                error={Boolean(errors.lastname)} 
                helperText={errors.lastname?.message} />
            )} />

          <ArcButton.brand 
            type='submit' 
            isLoading={isLoading}>
            Save
          </ArcButton.brand>

        </ArcStack>
      </ArcDialog>
    </React.Fragment>
  );
};

export default ChangeFullnameForm;